import type { useFinaleSectionModel } from '@/components/home/components/finale-section/finale-section.model'
import { ContactCtaViewModel } from '@/components/shared/contact-cta/contact-cta.view-model'
import { FooterViewModel } from '@/components/shared/footer/footer.view-model'

type FinaleSectionViewProps = ReturnType<typeof useFinaleSectionModel>

export function FinaleSectionView({
  eyebrowText,
  wordmarkText,
  contactHeadingText,
  slogan,
  deliveryLine,
  hoursLine,
  hoursNote,
  contactEmail,
  contactEmailHref,
  contactLabel,
  triggerText,
  stageInert,
  stageStyle,
  contentStyle,
}: FinaleSectionViewProps) {
  return (
    <section className="fz-finale">
      <h2 className="fz-sr-only">{contactHeadingText}</h2>
      <div className="fz-sr-only">
        <p>{deliveryLine}</p>
        <p>{hoursLine}</p>
        <p>{hoursNote}</p>
        <a href={contactEmailHref}>{contactEmail}</a>
      </div>
      <div
        className="fz-finale__stage"
        inert={stageInert || undefined}
        style={stageStyle}
      >
        <div className="fz-finale__content" style={contentStyle}>
          <span className="fz-finale__eyebrow">{eyebrowText}</span>
          <p className="fz-finale__wordmark">{wordmarkText}</p>
          <p className="fz-finale__slogan">{slogan}</p>
          <div className="fz-finale__info">
            <span className="fz-finale__info-line">{deliveryLine}</span>
            <span className="fz-finale__info-line">{hoursLine}</span>
            <span className="fz-finale__info-note">{hoursNote}</span>
          </div>
          <ContactCtaViewModel label={contactLabel} />
          <p className="fz-finale__trigger">{triggerText}</p>
          <a href={contactEmailHref} className="fz-finale__email">
            {contactEmail}
          </a>
        </div>
        <FooterViewModel />
      </div>
    </section>
  )
}
